/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechScreenTabletHIcon16Light } from './TechScreenTabletHIcon16Light';
import { TechScreenTabletHIcon16Regular } from './TechScreenTabletHIcon16Regular';
import { TechScreenTabletHIcon16Solid } from './TechScreenTabletHIcon16Solid';
import { TechScreenTabletHIcon20Light } from './TechScreenTabletHIcon20Light';
import { TechScreenTabletHIcon20Regular } from './TechScreenTabletHIcon20Regular';
import { TechScreenTabletHIcon20Solid } from './TechScreenTabletHIcon20Solid';
import { TechScreenTabletHIcon24Regular } from './TechScreenTabletHIcon24Regular';
import { TechScreenTabletHIcon24Solid } from './TechScreenTabletHIcon24Solid';
import { TechScreenTabletHIcon32Regular } from './TechScreenTabletHIcon32Regular';
import { TechScreenTabletHIcon64Regular } from './TechScreenTabletHIcon64Regular';
var sizes = {
    16: {
        light: TechScreenTabletHIcon16Light,
        regular: TechScreenTabletHIcon16Regular,
        solid: TechScreenTabletHIcon16Solid,
    },
    20: {
        light: TechScreenTabletHIcon20Light,
        regular: TechScreenTabletHIcon20Regular,
        solid: TechScreenTabletHIcon20Solid,
    },
    24: {
        regular: TechScreenTabletHIcon24Regular,
        solid: TechScreenTabletHIcon24Solid,
    },
    32: {
        regular: TechScreenTabletHIcon32Regular,
    },
    64: {
        regular: TechScreenTabletHIcon64Regular,
    },
};
export var TechScreenTabletHIcon = forwardRef('TechScreenTabletHIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
